export default {
	init() {
		let $html = $('html');
		let $backdrop = $('.backdrop');
		let $sectionShows = $('.section-shows');
		let $sectionVideos = $('.section-videos');
		let $sectionInstagram = $('.section-instagram');
		let $instagramSliderWrapper = $sectionInstagram.find('.fts-instagram-inline-block-centered');

		let $videoPlayButton = $('.video__play-button');
		let $videoPlayer = $('#global-video-player');
		let $videoPlayerWrapper = $videoPlayer.find('.video-player__wrapper');
		let $videoContainer = $videoPlayer.find('.video-player__video');
		let $videoCloseButton = $videoPlayer.find('.video-player__close-button');

		let $modalFormButton = $('.modal-form-trigger');
		let $modalForm = $('#modal-form');
		let $modalFormContainer = $modalForm.find('.modal-form__container');
		let $modalFormCloseButton = $modalForm.find('.modal-form__form-close-button');

		new Swiper($sectionShows.find('.swiper')[0], {
			slidesPerView: 'auto',
			spaceBetween: 20,
			speed: 1000,
			loop: true,
			navigation: {
				prevEl: $sectionShows.find('.show-slider-arrow--prev')[0],
				nextEl: $sectionShows.find('.show-slider-arrow--next')[0],
			}
		});

		new Swiper($sectionVideos.find('.swiper')[0], {
			slidesPerView: 1,
			spaceBetween: 20,
			speed: 1000,
			loop: true,
			navigation: {
				prevEl: $sectionVideos.find('.section-videos__slider-arrow--prev')[0],
				nextEl: $sectionVideos.find('.section-videos__slider-arrow--next')[0],
			},
			pagination: {
				el: $sectionVideos.find('.section-videos__slider-pagination')[0],
				clickable: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 50,
				}
			}
		});

		setTimeout(function() {
			$($instagramSliderWrapper[0]).infiniteslide({
				speed: 50,
				direction: 'left',
				pauseonhover: true,
				responsive: false,
				clone: getCloneCount($instagramSliderWrapper)
			});
		}, 5000);

		$videoPlayButton.click(function () {
			let $button = $(this);
			let $videoType = $button.data('video-type');
			let $videoURL = $button.data('video-url');
			let $videoPoster = $button.data('video-poster');
			let $videoMarkup = '';

			if ($videoURL) {
				$html.addClass('no-scroll');
				$backdrop.fadeIn();
				$videoPlayer.fadeIn();

				if ($videoType === 'youtube') {
					let $youtubeVideoID = getYouTubeVideoId($videoURL);

					$videoMarkup = `<iframe
										class="video-player__iframe"
										style="display: block;"
										width="100%"
										height="100%"
										src="https://www.youtube.com/embed/${$youtubeVideoID}?autoplay=1"
										frameborder="0"
										allow="autoplay; fullscreen"
										allowfullscreen
									>
									</iframe>`
				}

				else if ($videoType === 'self-hosted') {
					$videoMarkup = `<video
										disablePictureInPicture="true"
										autoplay="true"
										playsinline="true"
										controls "true"
										poster="${$videoPoster}"
										style="display: block;"
										width="100%"
										height="100%"
									>
										<source
											src="${$videoURL}"
											type="video/mp4"
										>
									</video>`
				}

				$videoContainer.html($videoMarkup);
			}
		});

		$videoCloseButton.click(function () {
			closeModal($videoPlayer);
		});

		$videoPlayerWrapper.click(function (element) {
			if ($(element.target).is($videoPlayerWrapper)) {
				closeModal($videoPlayer);
			}
		});

		$(document).keydown(function (e) {
			if (e.key === 'Escape' && $videoPlayer.is(':visible')) {
				closeModal($videoPlayer);
			}
		});

		$modalFormButton.click(function () {
			$html.addClass('no-scroll');
			$backdrop.fadeIn();
			$modalForm.fadeIn();
		});

		$modalFormCloseButton.click(function () {
			closeModal($modalForm);
		});

		$modalFormContainer.click(function (element) {
			if ($(element.target).is($modalFormContainer)) {
				closeModal($modalForm);
			}
		});

		$(document).keydown(function (e) {
			if (e.key === 'Escape' && $modalForm.is(':visible')) {
				closeModal($modalForm);
			}
		});

		function getYouTubeVideoId(url) {
			const regex =
			/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([^&?/]+)/;

			const match = url.match(regex);
			return match ? match[1] : null;
		}

		function closeModal ($element) {
			$html.removeClass('no-scroll');
			$backdrop.fadeOut();
			$element.fadeOut();

			if ($element.is($videoPlayer)) {
				$videoContainer.empty();
			}
		}

		function getCloneCount($container) {
			const $slide = $container.find('.fts-instagram-wrapper');
			const slideWidth = $slide.outerWidth();
			const sliderWidth = $container.outerWidth();
			const numberOfSlides = $slide.length;

			const requiredNumberOfSlides = Math.ceil( sliderWidth / slideWidth ) * 2;
			const result = Math.ceil( requiredNumberOfSlides / numberOfSlides ) - 1;

			return result < 1 ? 1 : result;
		}
	},
}